import React from "react"

import * as styles from "./PaginationControls.module.scss"

const PaginationControls = ({numPages, currentPage, onClickPage})=>{
  let pages = []
  if(numPages > 5) {
    pages = [1,2]
    if(currentPage > 2 && currentPage < numPages-1) {
      pages.push(currentPage)
    } else {
      pages.push(-1)
    }
    pages = pages.concat(numPages-1,numPages)
  } else {
    for(let i = 0; i < numPages; i++) {
      pages.push(i+1)
    }
  }
  
  return (
    <div className={styles.container}>
      <button disabled={currentPage===1} className={currentPage===1 ? styles.disabled : ""} onClick={()=>{onClickPage(currentPage-1)}}>{"<"}</button>
      {pages.map((pageNum)=>{
        if(pageNum === -1) {
          return (<button key="many" disabled={true}>{"..."}</button>)
        }
        return (
          <button className={currentPage===pageNum ? styles.active : ""} key={pageNum} disabled={pageNum===currentPage} onClick={()=>{onClickPage(pageNum)}}>{pageNum}</button>
        )
      })}
      <button disabled={currentPage===numPages} className={currentPage===numPages ? styles.disabled : ""} onClick={()=>{onClickPage(currentPage+1)}}>{">"}</button>
    </div>
  )
}

export default PaginationControls